import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import HomePage from "./ui/HomePage";

const Home = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <HomePage />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default Home;
